import React, { useRef, useEffect } from 'react';
import { ReactLenis } from 'lenis/react';
import { frame, cancelFrame } from 'motion';
import PropTypes from 'prop-types';

const LenisProvider = ({ children }) => {
    const lenisRef = useRef();

    useEffect(() => {
        function update(data) {
            const time = data.timestamp;
            lenisRef.current?.lenis?.raf(time);
        }

        frame.update(update, true);
        return () => cancelFrame(update);
    }, []);

    return (
        <ReactLenis
            ref={lenisRef}
            root
            options={{ smooth: true, autoRaf: false }}
        >
            {children}
        </ReactLenis>
    );
};

export default LenisProvider;

LenisProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
